import { render, staticRenderFns } from "./ChannelSchedules.vue?vue&type=template&id=e77f8954&scoped=true&"
import script from "./ChannelSchedules.vue?vue&type=script&lang=js&"
export * from "./ChannelSchedules.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSchedules.vue?vue&type=style&index=0&id=e77f8954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77f8954",
  null
  
)

export default component.exports